<div class="snackbar">
  <div>{{data.text}}</div>
  <div>
    <span class="material-icons" (click)="dismiss()">close</span>
    <div *ngIf="data.dismissText" class="dismiss-text" (click)="dismiss()">{{data.dismissText}}</div>
  </div>
</div>
<div>
  <mat-progress-bar *ngIf="data?.progress?.show" style="margin-top: 5px" [mode]="data.progress.mode" [value]="data.progress.perc"></mat-progress-bar>
</div>
